import { Column } from "@/components/Column";
import { Text } from "@/components/Text";
import { SadieSimulatorToolItem } from "@/components/tools/sadie-simulator/SadieSimulatorToolItem";

import { sadieSessionKindToLabel } from "@/lib/constants";
import { SadieSimulatorPrompt } from "@/types";

// The tools Sadie had on her last turn, as the model reads them. They come
// with that turn's prompt, so they follow the session it ran in.
export const SadieSimulatorTools = ({
  prompt,
}: {
  prompt: SadieSimulatorPrompt | null;
}) => {
  /* Helpers */
  const turnLabel = () => {
    if (!prompt?.sessionKind) return "On her last turn.";
    const session =
      sadieSessionKindToLabel[prompt.sessionKind] || prompt.sessionKind;
    return `On her last turn, in ${session}.`;
  };

  /* Render */
  const render = () => {
    if (!prompt) {
      return (
        <Text className="text-xs font-normal text-slate-500">
          Her tools show up here after her first reply.
        </Text>
      );
    }
    if (!prompt.tools) {
      return (
        <Text className="text-xs font-normal text-slate-500">
          This turn didn&apos;t say which tools she had. Send her another text.
        </Text>
      );
    }
    if (prompt.tools.length === 0) {
      return (
        <Text className="text-xs font-normal text-slate-500">
          {`${turnLabel()} She had no tools.`}
        </Text>
      );
    }
    return (
      <>
        <Text className="text-xs font-normal text-slate-500">
          {`${turnLabel()} Her prompt tells her when to use each.`}
        </Text>
        {prompt.tools.map((tool) => (
          <SadieSimulatorToolItem key={tool.name} tool={tool} />
        ))}
      </>
    );
  };

  return (
    <Column className="gap-2">
      <Text className="text-sm font-medium text-slate-700">Her tools</Text>
      {render()}
    </Column>
  );
};
